import { render } from "./DrawIndex.vue?vue&type=template&id=156c065d&scoped=true&ts=true"
import script from "./DrawIndex.vue?vue&type=script&lang=ts"
export * from "./DrawIndex.vue?vue&type=script&lang=ts"

import "./DrawIndex.vue?vue&type=style&index=0&id=156c065d&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156c065d"]])

export default __exports__